import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { PrintableCheck } from '../../../../../models/entities/printable-check';
import { CommonModule } from '@angular/common';
import { LegfiDatePipe } from 'app/pipes/format/legfi-date.pipe';

@Component({
  selector: 'app-check-printing-preview',
  templateUrl: './check-printing-preview.component.html',
    styleUrls: ['./check-printing-preview.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LegfiDatePipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckPrintingPreviewComponent implements OnInit {

    @Input() check: PrintableCheck;
    @Input() displayVendorAddress: boolean = false;

    constructor() { }

    ngOnInit(): void {
    }

}
